import axios from "axios";
import { Baseurl } from "../baseurl";
import { toast } from "react-toastify";

export const fetchTickets = async () => {
  try {
    const response = await axios.get(`${Baseurl}/api/contact/all-tickets`);
    // setTickets(response.data.data);
    // setError(null);
    return response.data
  } catch (err) {
    // setError("Failed to fetch tickets. Please try again.");
    toast.error("Error fetching support tickets");
    console.error("Error fetching tickets:", err);
  } finally {
    // setLoading(false);
  }
};
